import styled from 'styled-components'

export const Container = styled.section`
  text-align: center;
  margin: 100px 0 80px 0;
  .main-titles{
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    text-align: center;
    z-index: 2;
    small{
      font-weight: 700;
      font-size: 14px;
      line-height: 1.57;
    }
    h5{
      font-size: 15px;
      color: var(--title-color);
      line-height: 1.5;
      margin-bottom: 16px;
    }
    h1{
      line-height: .93;
      font-size: 55px;
      font-weight: 700;
    }
  }
  @media screen and (max-width: 599px){
    h1, h1 {
      font-size: 30px;
      line-height: 1.1;
    }
  }
`
